// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("./utils.res.js");
var RichTextToolbar$ReactHooksTemplate = require("./RichTextToolbar.res.js");

var defaultToolbarState = {
  bold: false,
  italic: false,
  underline: false,
  justifyLeft: false,
  justifyCenter: false,
  justifyRight: false,
  justifyFull: false,
  unorderedList: false,
  orderedList: false
};

function updateToolbarState(ref) {
  if (!RichTextToolbar$ReactHooksTemplate.isSelectionInEditor(ref)) {
    return defaultToolbarState;
  }
  var align = RichTextToolbar$ReactHooksTemplate.getSelectionAlignment(ref);
  return {
          bold: RichTextToolbar$ReactHooksTemplate.queryCommandState("bold"),
          italic: RichTextToolbar$ReactHooksTemplate.queryCommandState("italic"),
          underline: RichTextToolbar$ReactHooksTemplate.queryCommandState("underline"),
          justifyLeft: align === "left",
          justifyCenter: align === "center",
          justifyRight: align === "right",
          justifyFull: align === "justify",
          unorderedList: RichTextToolbar$ReactHooksTemplate.queryCommandState("insertUnorderedList"),
          orderedList: RichTextToolbar$ReactHooksTemplate.queryCommandState("insertOrderedList")
        };
}

function RichTextEditor(props) {
  var __showLists = props.showLists;
  var __showAlignment = props.showAlignment;
  var __singleLine = props.singleLine;
  var __minHeight = props.minHeight;
  var label = props.label;
  var onChange = props.onChange;
  var value = props.value;
  var minHeight = __minHeight !== undefined ? __minHeight : "2.25rem";
  var singleLine = __singleLine !== undefined ? __singleLine : false;
  var showAlignment = __showAlignment !== undefined ? __showAlignment : true;
  var showLists = __showLists !== undefined ? __showLists : true;
  var editorRef = React.useRef(null);
  var match = React.useState(function (param) {
        return defaultToolbarState;
      });
  var setToolbarState = match[1];
  var toolbarState = match[0];
  var match$1 = React.useState(function (param) {
        return false;
      });
  var setShowLinkInput = match$1[1];
  React.useEffect((function (param) {
          RichTextToolbar$ReactHooksTemplate.setRefHtml(editorRef, value);
        }), [
        value,
        undefined
      ]);
  React.useEffect((function (param) {
          var handler = function (param) {
            Curry._1(RichTextToolbar$ReactHooksTemplate.saveSelection, editorRef);
            Curry._1(setToolbarState, (function (param) {
                    return updateToolbarState(editorRef);
                  }));
          };
          return ((function(handler) {
        document.addEventListener("selectionchange", handler);
        return function() {
          document.removeEventListener("selectionchange", handler);
        };
      }))(handler);
        }), []);
  var ensureSelectionForToolbarAction = function (param) {
    if (RichTextToolbar$ReactHooksTemplate.isSelectionInEditor(editorRef)) {
      return Curry._1(RichTextToolbar$ReactHooksTemplate.saveSelection, editorRef);
    } else {
      RichTextToolbar$ReactHooksTemplate.restoreSelection(editorRef);
      if (!RichTextToolbar$ReactHooksTemplate.isSelectionInEditor(editorRef)) {
        return RichTextToolbar$ReactHooksTemplate.focusRef(editorRef);
      } else {
        return ;
      }
    }
  };
  var applyHyperlink = function (linkText, url) {
    if (url === "") {
      RichTextToolbar$ReactHooksTemplate.execCommand("unlink", "");
    } else {
      RichTextToolbar$ReactHooksTemplate.restoreSelection(editorRef);
      if (linkText === "") {
        RichTextToolbar$ReactHooksTemplate.execCommand("createLink", url);
      } else {
        RichTextToolbar$ReactHooksTemplate.execCommand("insertHTML", "<a href=\"" + url + "\" target=\"_blank\" rel=\"noopener noreferrer\">" + linkText + "</a>");
      }
      RichTextToolbar$ReactHooksTemplate.setLinkTargetAndRel();
    }
    Curry._1(setShowLinkInput, (function (param) {
            return false;
          }));
  };
  return JsxRuntime.jsxs("div", {
              children: [
                label !== undefined ? JsxRuntime.jsx("div", {
                        children: label,
                        className: "block text-aurometalsaurus text-xs font-medium mb-1"
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                              label: "<strong>B</strong>",
                              title: "Bold",
                              onAction: (function (param) {
                                  ensureSelectionForToolbarAction();
                                  RichTextToolbar$ReactHooksTemplate.execCommand("bold", "");
                                  Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                                }),
                              active: toolbarState.bold
                            }),
                        JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                              label: "<em>I</em>",
                              title: "Italic",
                              onAction: (function (param) {
                                  ensureSelectionForToolbarAction();
                                  RichTextToolbar$ReactHooksTemplate.execCommand("italic", "");
                                  Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                                }),
                              active: toolbarState.italic
                            }),
                        JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                              label: "<span style='text-decoration: underline;'>U</span>",
                              title: "Underline",
                              onAction: (function (param) {
                                  ensureSelectionForToolbarAction();
                                  RichTextToolbar$ReactHooksTemplate.execCommand("underline", "");
                                  Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                                }),
                              active: toolbarState.underline
                            }),
                        JsxRuntime.jsx("div", {
                              className: "w-px self-stretch bg-gray-300 rounded-full opacity-70 min-h-5",
                              role: "presentation"
                            }),
                        JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.TextColorPicker.make, {
                              onSelectColor: (function (hex) {
                                  RichTextToolbar$ReactHooksTemplate.execCommand("foreColor", hex);
                                })
                            }),
                        JsxRuntime.jsx("div", {
                              className: "w-px self-stretch bg-gray-300 rounded-full opacity-70 min-h-5",
                              role: "presentation"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                                      label: "<span style='text-decoration: none;'>Link</span>",
                                      title: "Insert link",
                                      onAction: (function (param) {
                                          Curry._1(RichTextToolbar$ReactHooksTemplate.saveSelection, editorRef);
                                          Curry._1(setShowLinkInput, (function (param) {
                                                  return true;
                                                }));
                                        })
                                    }),
                                match$1[0] ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.HyperlinkInput.make, {
                                              onApply: applyHyperlink,
                                              onCancel: (function (param) {
                                                  Curry._1(setShowLinkInput, (function (param) {
                                                          return false;
                                                        }));
                                                })
                                            }),
                                        className: "absolute left-0 top-full mt-2 z-20 min-w-72"
                                      }) : null
                              ],
                              className: "relative"
                            }),
                        showAlignment ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        className: "w-px self-stretch bg-gray-300 rounded-full opacity-70 min-h-5",
                                        role: "presentation"
                                      }),
                                  JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                                        label: "<span>&#8676;</span>",
                                        title: "Align left",
                                        onAction: (function (param) {
                                            ensureSelectionForToolbarAction();
                                            RichTextToolbar$ReactHooksTemplate.applyAlignment(editorRef, "left");
                                            Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                                          }),
                                        active: toolbarState.justifyLeft
                                      }),
                                  JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                                        label: "<span>&#8596;</span>",
                                        title: "Align center",
                                        onAction: (function (param) {
                                            ensureSelectionForToolbarAction();
                                            RichTextToolbar$ReactHooksTemplate.applyAlignment(editorRef, "center");
                                            Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                                          }),
                                        active: toolbarState.justifyCenter
                                      }),
                                  JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                                        label: "<span>&#8677;</span>",
                                        title: "Align right",
                                        onAction: (function (param) {
                                            ensureSelectionForToolbarAction();
                                            RichTextToolbar$ReactHooksTemplate.applyAlignment(editorRef, "right");
                                            Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                                          }),
                                        active: toolbarState.justifyRight
                                      }),
                                  JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                                        label: "<span>&#8660;</span>",
                                        title: "Justify",
                                        onAction: (function (param) {
                                            ensureSelectionForToolbarAction();
                                            RichTextToolbar$ReactHooksTemplate.applyAlignment(editorRef, "justify");
                                            Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                                          }),
                                        active: toolbarState.justifyFull
                                      })
                                ]
                              }) : null,
                        showLists ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        className: "w-px self-stretch bg-gray-300 rounded-full opacity-70 min-h-5",
                                        role: "presentation"
                                      }),
                                  JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                                        label: "<span>&bull; List</span>",
                                        title: "Bulleted list",
                                        onAction: (function (param) {
                                            ensureSelectionForToolbarAction();
                                            RichTextToolbar$ReactHooksTemplate.execCommand("insertUnorderedList", "");
                                            RichTextToolbar$ReactHooksTemplate.applyAlignment(editorRef, "left");
                                            Curry._1(RichTextToolbar$ReactHooksTemplate.saveSelection, editorRef);
                                            Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                                          }),
                                        active: toolbarState.unorderedList
                                      }),
                                  JsxRuntime.jsx(RichTextToolbar$ReactHooksTemplate.ToolbarButton.make, {
                                        label: "<span>1. List</span>",
                                        title: "Numbered list",
                                        onAction: (function (param) {
                                            ensureSelectionForToolbarAction();
                                            RichTextToolbar$ReactHooksTemplate.execCommand("insertOrderedList", "");
                                            RichTextToolbar$ReactHooksTemplate.applyAlignment(editorRef, "left");
                                            Curry._1(RichTextToolbar$ReactHooksTemplate.saveSelection, editorRef);
                                            Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                                          }),
                                        active: toolbarState.orderedList
                                      })
                                ]
                              }) : null
                      ],
                      className: "flex items-center flex-wrap gap-1 mb-2 px-1.5 py-1 min-h-7 bg-gray-50 border border-gray-200 rounded shadow-sm"
                    }),
                JsxRuntime.jsx("div", {
                      ref: Caml_option.some(editorRef),
                      className: "rich-text-editor-content py-1.5 px-2 bg-alicebluepurple border border-gray-200 rounded text-xs text-gray-800 w-full outline-none transition-colors focus:border-bleudefrance focus:ring-2 focus:ring-bleudefrance/20 leading-snug",
                      contentEditable: true,
                      style: {
                        minHeight: minHeight
                      },
                      onPaste: (function ($$event) {
                          if (singleLine) {
                            return Utils$ReactHooksTemplate.pasteAsSingleLinePlainText($$event);
                          } else {
                            return Utils$ReactHooksTemplate.pasteAsPlainText($$event);
                          }
                        }),
                      onKeyDown: (function ($$event) {
                          if (singleLine && $$event.key === "Enter") {
                            $$event.preventDefault();
                            return ;
                          }
                          
                        }),
                      onBlur: (function (param) {
                          Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                        }),
                      onInput: (function (param) {
                          Curry._1(onChange, RichTextToolbar$ReactHooksTemplate.getRefHtml(editorRef));
                        }),
                      suppressContentEditableWarning: true
                    })
              ],
              className: "flex flex-col w-full max-w-2xl"
            });
}

var make = RichTextEditor;

exports.defaultToolbarState = defaultToolbarState;
exports.updateToolbarState = updateToolbarState;
exports.make = make;
/* react Not a pure module */
